var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader"}},[_c('img',{attrs:{"src":require("@/assets/images/loader.gif"),"alt":""}})])
}]

export { render, staticRenderFns }